'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _label = require('../ipos/label');

var _label2 = _interopRequireDefault(_label);

var _label3 = require('../mobile/label');

var _label4 = _interopRequireDefault(_label3);

var _label5 = require('../points/label');

var _label6 = _interopRequireDefault(_label5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = _util2.default.create,
    emit = _util2.default.emit;

var vipLevelImages = {
  '0': 'http://img.thebeastshop.com/apppictures/2017-07-12/5f7fdc7bd73dc83f4318a918cfb771ac.jpg',
  '1': 'http://img.thebeastshop.com/apppictures/2017-07-12/9460e395b4ee15b1f8426b9f5d87e1a0.png',
  '2': 'http://img.thebeastshop.com/apppictures/2017-07-12/65decd7cdc9d6f45fd34dfa4aaf2ba8b.png',
  '3': 'http://img.thebeastshop.com/apppictures/2017-07-12/cc963fc32858fbf03e6d9b80d842d8e9.png'
};

var Pack = function (_EventEmitter) {
  (0, _inherits3.default)(Pack, _EventEmitter);

  function Pack(data) {
    (0, _classCallCheck3.default)(this, Pack);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Pack.__proto__ || (0, _getPrototypeOf2.default)(Pack)).call(this));

    _this.data = data;
    _this.setDefault();
    _this.setLabelModel();
    return _this;
  }

  (0, _createClass3.default)(Pack, [{
    key: 'setDefault',
    value: function setDefault() {
      var data = this.data;
      data.editMode = false;
      data.p_checked = false;
      data.p_editModeChecked = false;
      data.showDeleteBtn = false;
      this.resetDefault(data);
      this.setSpvDescText();
      this.setPresellText();
      this.setBenefitText();
      this.setPriceTags();
      this.setCountStatus();
    }
  }, {
    key: 'guid',
    value: function guid() {
      return this.data.g_uid;
    }
  }, {
    key: 'getLabelModel',
    value: function getLabelModel() {
      var Model = {
        'ipos': _label2.default,
        'mobile': _label4.default,
        'points': _label6.default
      };
      return Model[_util2.default.getClient()];
    }
  }, {
    key: 'setLabelModel',
    value: function setLabelModel() {
      var _this2 = this;

      var Label = this.getLabelModel();
      this.labels = [];
      this.data.labels.forEach(function (l) {
        var label = create(Label, l, 'LABEL');
        _this2.labels.push(label);
      });
      this.data.giftPacks.forEach(function (l) {
        var label = create(Label, l, 'GIFT');
        if (_util2.default.getClient() == 'ipos') {
          label.on('refresh-preview', function () {
            _this2.emit('refresh-preview');
          });
        }
        _this2.labels.push(label);
      });
    }
  }, {
    key: 'resetDefault',
    value: function resetDefault(data) {
      !data.labels && (data.labels = []);
      !data.giftPacks && (data.giftPacks = []);
    }
  }, {
    key: 'setSpvDescText',
    value: function setSpvDescText() {
      var data = this.data;
      if (data.customized) {
        !data.customizes && (data.customizes = []);
        var desc = '';
        data.customizes.forEach(function (el) {
          desc += el.name + ':' + el.value.replace(/\[\[love\]\]/g, '❤️') + ';';
        });
        // return desc
        data.spvDescText = desc;
      } else {
        // return data.spv.spvDesc
        data.spvDescText = data.spv.spvDesc;
      }
    }
  }, {
    key: 'setPresellText',
    value: function setPresellText() {
      var presell = this.data.spv.presell;
      this.data.presellText = presell && presell.content || '';
    }
  }, {
    key: 'setBenefitText',
    value: function setBenefitText() {
      var d = this.data;
      var text = '';
      if (d.source === 'BENEFIT' && d.benefit) {
        text = d.invalid && d.invalid.desc || '';
      }
      d.benefitText = text;
    }
  }, {
    key: 'setPriceTags',
    value: function setPriceTags() {
      var spv = this.data.spv;
      var tags = void 0;
      if (spv.discount) {
        tags = {
          vipLevelImage: spv.discount.vipLevel !== null && vipLevelImages[spv.discount.vipLevel],
          // appOnlyImage: spv.discount.appOnly && 'http://img.thebeastshop.com/apppictures/2017-07-12/a139293dcdbcd72afa4d2b77a5698d42.png',
          birthdayImage: spv.discount.birthday && 'http://img.thebeastshop.com/apppictures/2017-07-12/7860dfcf031b72f2d3bf0c14b3e6f7c3.png'
        };
      } else {
        tags = {};
      }
      this.data.priceTags = tags;
    }
  }, {
    key: 'setAchieveMin',
    value: function setAchieveMin() {
      if (this.data.source === 'BENEFIT') {
        // return true
        this.data.achieveMin = true;
        return;
      }
      var min = this.data.spv.minAmount || 1;
      this.data.achieveMin = this.data.count <= min;
    }
  }, {
    key: 'setAchieveMax',
    value: function setAchieveMax() {
      if (this.data.source === 'BENEFIT') {
        // return true
        this.data.achieveMax = true;
        return;
      }
      var spv = this.data.spv;
      var max = void 0;
      if (spv.quota) {
        max = Math.min(spv.left, spv.quota.left);
      } else {
        max = spv.left;
      }
      this.data.achieveMax = this.data.count >= max;
    }
  }, {
    key: 'setCountStatus',
    value: function setCountStatus() {
      this.setAchieveMax();
      this.setAchieveMin();
    }
  }, {
    key: 'formatDate',
    value: function formatDate(time) {
      var date = new Date(time);
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }
  }, {
    key: 'packCheckboxTap',
    value: function packCheckboxTap() {
      if (this.data.editMode) {
        if (this.data.source === 'BENEFIT') {
          return;
        }
        this.data.p_editModeChecked = !this.data.p_editModeChecked;
      } else {
        if (this.data.invalid && this.data.invalid.invalid) {
          return;
        }
        this.data.p_checked = !this.data.p_checked;
      }
      this.emit('select-change');
    }
  }, {
    key: 'select',
    value: function select(editMode) {
      if (editMode) {
        this.data.p_editModeChecked = true;
      } else {
        this.data.p_checked = true;
      }
    }
  }, {
    key: 'countTap',
    value: function countTap(action) {
      var count = action === 'add' ? this.data.count + 1 : this.data.count - 1;
      if (action === 'add' && this.data.achieveMax) {
        return;
      }
      if (action === 'sub' && this.data.achieveMin) {
        return;
      }
      this.setCount(count, action);
    }
  }, {
    key: 'setCount',
    value: function setCount(count, action) {
      var _this3 = this;

      if (this.countPending) {
        return;
      }
      this.countPending = true;
      this.modifyCount(count).then(function (_ref) {
        var data = _ref.data;

        _this3.countPending = false;
        _util2.default.track(action === 'add' ? 'pack-add' : 'pack-sub');
        _this3.data.count = count;
        _this3.data.customCard = data[0].customCard;

        _this3.setCountStatus();
        if (_util2.default.getClient() === 'ipos') {
          var spv = _this3.data.spv;
          if (spv.newcomerTag && spv.quota && spv.quota.left < _this3.data.count) {
            _this3.data.count = spv.quota.left;
            emit('error', {
              message: '超过最大购买数量'
            });
            return;
          }
          _this3.emit('refresh-preview', _this3.data.g_uid);
        } else {
          _this3.data.labels = data[0].labels || [];
          _this3.data.giftPacks = data[0].giftPacks || [];
          _this3.setLabelModel();
        }
      }).catch(function (_ref2) {
        var message = _ref2.message;

        _this3.countPending = false;
        emit('error', {
          message: message
        });
      });
    }
  }, {
    key: 'modifyCount',
    value: function modifyCount(count) {
      var data = [{
        "id": this.data.id,
        "spvId": this.data.spv.id,
        "count": count
      }];
      return this.modify(data);
    }
  }, {
    key: 'modifyVariant',
    value: function modifyVariant(result, callback) {
      var data = [{
        "id": this.data.id,
        "spvId": result.spvId,
        "count": result.count
      }];
      return this.modify(data);
    }
  }, {
    key: 'setVariant',
    value: function setVariant(_ref3) {
      var _this4 = this;

      var result = _ref3.result,
          variant = _ref3.variant;

      return this.modifyVariant(result).then(function () {
        variant.spvs.forEach(function (spv) {
          if (spv.id === result.spvId) {
            _this4.data.spv = spv;
          }
        });
        _this4.setSpvDescText();
      });
    }
  }, {
    key: 'editMode',
    value: function editMode(val) {
      val && (this.data.p_editModeChecked = false);
      this.data.editMode = val;
      this.labels.forEach(function (label) {
        label.editMode(val);
      });
    }
  }]);
  return Pack;
}(_events.EventEmitter);

exports.default = Pack;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/base/pack.js
// module id = 670
// module chunks = 0